import { Component, OnInit } from '@angular/core';
import { NgForm } from '@angular/forms';
import { Response } from '@angular/http';
import { AdminService } from '../../../services/admin.service';
import { Standard } from '../../../models/standard.model';
import { FullUser } from '../../../models/full-user.model';
import { UserService } from '../../../services/user.service';
import { Status } from '../../../models/status.model';
import { Group } from '../../../models/group.model';
import { CreatingStandard } from '../../../models/creating-standard.model';
import { Question } from '../../../models/question.model';
import { ConfirmationPopupComponent } from '../../views/view-group/popups/confirmation-popup/confirmation-popup.component';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Answer } from '../../../models/answer.model';
import { NewBlank } from '../../../models/new-blank.model';
import { MultiQuestions } from '../../../models/multi-questions';
import * as moment from 'moment';
import { PrefixService } from '../../../services/frefix.service';
import { EditStandardPrefixComponent } from '../../admin/create-standard/modal/edit-standard-prefix/edit-standard-prefix.component';
import { AddStandardPrefixComponent } from '../../admin/create-standard/modal/add-standard-prefix/add-standard-prefix.component';
import { StandardTypesService } from '../../../services/standard-types.service';
import { StandardType } from '../../../models/standard-type.model';
import { AddStandardTypeComponent } from '../../admin/create-standard/modal/add-standard-type/add-standard-type.component';
import { EditStandardTypeComponent } from '../../admin/create-standard/modal/edit-standard-type/edit-standard-type.component';
import { EditStandardNumberComponent } from '../../admin/create-standard/modal/edit-standard-number/edit-standard-number.component';
import { TreeGroupPosService } from '../create-operating-standard/tree-group-pos-service/tree-group-pos.service';
import { StepsControllerService } from "../../../services/steps-controller.service";
import { User } from '../../../models/user.model';

@Component({
	selector: 'app-create-standard',
	templateUrl: './create-standard.component.html',
	styleUrls: ['./create-standard.component.css']
})

export class CreateStandardComponent implements OnInit {
	isLoaded = false;
	stringDate: string;
	generadedNumber: string;
	numberCountToday: number;
	standardNumber: string;
	selectedGroupObj: Group;
	users = [];
	groups: any = [];
	activeStep = 1;
	list = [];
	nextButText = 'NEXT';
	formData: FormData = new FormData();
	initiator: FullUser;
	groupStandardId: string;
	statuses = Status;
	status: Status = Status.ACTIVE;
	statusText: 'ACTIVE';
	selPositions: string[] = [];
	selGroups: string[] = [];
	selUsers: string[] = [];
	russianQuestions: Question[] = [];
	englishQuestions: Question[] = [];
	questionList: any[] = [];
	newBlanks: NewBlank[] = [];
	failedRetrieveEntities = false;
	failedStandardCreation = false;
	createSuccess = false;
	standard: any;
	ruDocLoaded: boolean;
	ruPptLoaded: boolean;
	ruPdfLoaded: boolean;
	enDocLoaded: boolean;
	enPptLoaded: boolean;
	enPdfLoaded: boolean;
	needMoreQuestions = false;
	errorMessage = '';
	invalidQuestions = false;
	selectedType: StandardType;
	creatingStatusText = '';
	newList = [];
	showCreateError = false;
	disableBtnCreateStandard = false;
	user: User;
	isAdmin = false;
	isHead = false;
	isUser = false;
	flag = true;
	flagNg = true;
	isSelected = false;
	checkbox=true;

	isNextButtonHovered = false;
	highlightStep1Name = false;
	highlightStep1Annotation = false;
	highlightStep2Document = false;

	constructor(private userService: UserService,
		private adminService: AdminService,
		private modalService: NgbModal,
		public prefixService: PrefixService,
		public standardTypesService: StandardTypesService,
		public treeGroupPosService: TreeGroupPosService,
		public setpsControllService: StepsControllerService) {
	}

	ngOnInit() {
		this.checkRole()
		this.creatingStatusText = '';
		this.showCreateError = false;
		this.disableBtnCreateStandard = false;
		this.isLoaded = false;
		this.stringDate = moment().format('DD.MM.YYYY');

		// GET ACTIVE USERS
		this.getUsersByIdGroup(JSON.parse(localStorage.getItem('User')).mainGroup);

		// GET ALL GROUPS
		this.adminService.getAllGroupsForList().subscribe(
			(response: any) => {
				if (response.status === 200) {
					let arr = response.body;
					let b = JSON.parse(localStorage.getItem('User')).mainGroup;
					const relatedId = arr.findIndex(({ id }) => id === b);
					const [related] = arr.splice(relatedId, 1);
					this.groups = arr;
					this.filterBy('name', 'departments');
					this.groups.unshift(related);
					this.groupStandardId = this.groups[0].id;
					this.selectedGroupObj = this.groups[0];
					this.setDivisionInitiator(this.groups[0].id);
					this.prefixService.setActiveInitiatorGroup(this.selectedGroupObj);
					this.retryGroups();
					this.users.push(this.groups[0].head);
					this.initiator = this.users[0];
				}
			},
			(error) => {
				this.failedRetrieveEntities = true;
			},
			() => {
				this.retryGroups();
			}
		);
	}
	
	getUsersByIdGroup(id) {
		this.userService.getUsersByIdGroup(id).subscribe(
			(response: any) => {
				if (response.status === 200) {
					if (this.isAdmin && this.isHead) {
						let arr = response.body;
						let b = JSON.parse(localStorage.getItem('User')).fullName;
						const relatedId = arr.findIndex(({ fullName }) => fullName === b);
						const [related] = arr.splice(relatedId, 1);
						this.users = arr;
						this.filterBy('firstName', 'users');
						this.users.unshift(related);
						this.initiator = this.users[0];
					} else if (this.isAdmin && !this.isHead) {
						this.users = response.body;
						this.initiator = this.users[0];
					}
				} else if (response.status === 204) {
					this.users = [];
				}
			},
			(error) => {
				this.failedRetrieveEntities = true;
			}
		);
	}

	ffffQuestionTest(i, value){
		if(value) {
			this.questionList[i].checked = false;
		} else {
			this.questionList[i].checked = true;
		}
	}

	changeQuestionTest(i, value) {
		this.questionList[i].questionTextRu = value;
		this.questionList[i].questionTextEn = value;
		this.chekQuestionArr();
	}

	chekQuestionArr() {
		var n = this.questionList.length;
		for (var i = 0; i < n-1; i++)
		{ for (var j = i+1; j < n; j++)
			{ if (this.questionList[i].questionTextRu === this.questionList[j].questionTextRu) return false; }
		}
		return true;
	}

	changeAnswerOne(i, value) {
		this.questionList[i].answers[0].answerOneRu = value;
		this.questionList[i].answers[0].answerOneEn = value;
	}

	changeAnswerTwo(i, value) {
		this.questionList[i].answers[0].answerTwoRu = value;
		this.questionList[i].answers[0].answerTwoEn = value;
	}

	changeAnswerThree(i, value) {
		this.questionList[i].answers[0].answerThreeEn = value;
		this.questionList[i].answers[0].answerThreeRu = value;
	}

	changeRightAnswer(i, value) {
		this.questionList[i].rightAnswerRu = value;
		this.questionList[i].rightAnswerEn = value;
	}

	
	fileChange(typeRu: string, typeEn: string, event) {
		this.ruSet(typeRu, event);
	}

	fileChangePresent(typeRu: string, typeEn: string, event) {
		this.ruSet(typeRu, event);
	}	

	ruSet(type, event){
		const fileList = event.target.files;
		if (fileList.length > 0) {
		  const file: File = fileList[0];
		  this.formData.set(type, file, file.name);
		  this.list.push(file.name);
		  if(type === 'RU_DOC') {
		    this.ruDocLoaded = true;
		  }
		} else {
		  this.formData.delete(type);
		  if(type === 'RU_DOC') {
		    this.ruDocLoaded = false;
		  }
		}
	}
	
	enSet(type, event){
		const fileList = event.target.files;
		if (fileList.length > 0) {
		  const file: File = fileList[0];
		  this.formData.set(type, file, file.name);
		  this.list.push(file.name);
		} else {
		  this.formData.delete(type);
		}
	}

	checkRole() {
		this.user = this.userService.getLocal();
		if (this.user.roles.indexOf('ROLE_HEAD') !== -1) {
			this.isHead = true;
		} else {
			this.isHead = false;
		}
		if (this.user.roles.indexOf('ROLE_ADMIN') !== -1) {
			this.isAdmin = true;
		} else {
			this.isAdmin = false;
		}
		if (this.user.roles.indexOf('ROLE_USER') !== -1) {
			this.isUser = true;
		} else {
			this.isUser = false;
		}
	}
	
	retryGroups() {
		this.prefixService.getPrefixesForGroup(this.selectedGroupObj.id).subscribe(
			(response: any) => {
				if (response.status === 200) {
					this.prefixService.setGroupPrefixex(response.body);
					this.prefixService.setSelectedPrefix(this.prefixService.getGroupPrefixex()[0]);

					this.setCounterNum(this.prefixService.getSelectedPrefix());

					if (this.prefixService.getSelectedPrefix()) {
						this.standardNumber = this.prefixService.getSelectedPrefix().name + this.generadedNumber;
						this.prefixService.customStndNumber = this.prefixService.getSelectedPrefix().name + this.generadedNumber;
					} else {
						if (this.prefixService.getGroupPrefixex().length > 0) {
							this.standardNumber = this.prefixService.getGroupPrefixex()[0].name + this.generadedNumber;
							this.prefixService.customStndNumber = this.prefixService.getGroupPrefixex()[0].name + this.generadedNumber;
						} else {
							this.standardNumber = this.generadedNumber;
							this.prefixService.customStndNumber = this.generadedNumber;
						}
					}
					this.isLoaded = true;
				} else if (response.status === 204) {
					this.isLoaded = true;
					this.prefixService.setGroupPrefixex([]);
					this.prefixService.setSelectedPrefix(null);
				}
			},
			() => {
				this.isLoaded = true;
				this.failedRetrieveEntities = true;
			},
			() => {
				this.isLoaded = true;
			}
		);


		// GET TYPES BY GROUP ID
		this.standardTypesService.getTypesForGroup(this.selectedGroupObj.id).subscribe(
			(res: any) => {
				if (res.status === 200) {
					// UPDATE TYPES LIST
					this.updateTypes(res.body);
				}
			},
			() => {
			}
		);
	}

	diabledNextSteps(form) {
		return this.isValid(form) && this.treeGroupPosService.isValid();
	}

	goToStepOne() {
		this.activeStep = 1;
		this.nextButText = 'NEXT';
	}

	goToStepTwo() {
		this.activeStep = 2;
		this.nextButText = 'NEXT';
	}

	goToStepThree() {
		this.activeStep = 3;
		this.nextButText = 'NEXT';
	}

	goToPrev() {
		if (this.activeStep > 1) {
			this.activeStep--;
			this.nextButText = 'NEXT';
		}
		if (this.activeStep < 1) {
			this.activeStep = 1;
		}
	}

	goToNext() {
		if (this.activeStep < 3) {
			this.activeStep++;
		}
		if (this.activeStep > 3) {
			this.activeStep = 3;
		}
	}

	addQuestionToList() {
		this.questionList.push(
			{
				checked: true,
				questionTextRu: '',
				questionTextEn: '',
				rightAnswerRu: '',
				rightAnswerEn: '',
				answers: [
					{
						answerOneRu: '',
						answerTwoRu: '',
						answerThreeRu: '',
						answerOneEn: '',
						answerTwoEn: '',
						answerThreeEn: '',
					}
				]
			}
		);
	}

	validationBlank(blank) {
		return blank.number !== null &&
			blank.name !== null &&
			blank.formData;
	}

	cnhageBlankInfo(event, i){
		this.newBlanks[i].name = event;
		this.newBlanks[i].number = this.prefixService.customStndNumber + '_blank_' + (i + 1);
	}

	private validationAllBlanks(newBlanks: NewBlank[]): boolean {
		for (const blank of newBlanks) {
			if (!this.validationBlank(blank)) {
				return false;
			}
		}
		return true;
	}

	addNewBlank() {
		this.newBlanks.push(new NewBlank(null, null, null));
	}

	deleteBlank(key) {
		if (key > -1) {
			this.newBlanks.splice(key, 1);
		}
	}

	deleteQuestionFromList(key) {
		if (key > -1) {
			this.questionList.splice(key, 1);
		}
	}

	setInitiator(login: string): void {
		this.initiator = this.users.find(value => value.login === login);
	}

	setStatus(status): void {
		this.statusText = status;
	}


	isValidQuestion(answerOne, answerTwo, answerThree): boolean {
		return answerOne === answerTwo ||
			answerOne === answerThree;
	}

	sendRequest(form: NgForm): void {
		const modalRef = this.modalService.open(ConfirmationPopupComponent);
		modalRef.componentInstance.massage = 'E_C';
		modalRef.result.then((result) => {
			if (result === 'ok') {
				this.isLoaded = false;
				this.createStandard(form);
			}
		});
	}


	createStandard(form: NgForm) {
		this.disableBtnCreateStandard = true;
		this.showCreateError = false;
		this.needMoreQuestions = false;
		this.errorMessage = '';
		this.invalidQuestions = false;
		this.createSuccess = false;
		if (this.questionList.length < 5 || !this.chekQuestionArrValue()) {
			this.needMoreQuestions = true;
			this.errorMessage = 'YOU_NEED_AT_LEAST_FIVE_QUESTIONS';
			this.disableBtnCreateStandard = false;
		} else if (!this.chekQuestionArr()) {
			this.invalidQuestions = true;
			this.disableBtnCreateStandard = false;
		} else {
			// FILES
			if (this.formData.has('RU_DOC')) {
				if (this.treeGroupPosService.isValid()) {
					// TYPES
					if (this.standardTypesService.getSelectedType() !== undefined &&
						this.standardTypesService.getSelectedType() !== null) {
						// PREFIXES
						if (this.prefixService.getSelectedPrefix() !== undefined &&
							this.prefixService.getSelectedPrefix() !== null) {
							// MAIN INFO
							form.value.enAnnotation = form.value.ruAnnotation;
							form.value.enName = form.value.ruName;
							form.value.enType = form.value.ruType;
							if (this.isValid(form)) {
								if (this.validationAllBlanks(this.newBlanks)) {
									this.creatingStatusText = 'CREATING_THE_STANDARD';
									const newStandard: CreatingStandard = new CreatingStandard(
										this.stringDate,
										{
											id: this.standardTypesService.getSelectedType().id,
											ruName: this.standardTypesService.getSelectedType().ruName,
											enName: this.standardTypesService.getSelectedType().ruName
										},
										this.prefixService.customStndNumber,
										this.initiator.id,
										this.groupStandardId,
										form.value.ruAnnotation,
										form.value.ruName,
										form.value.ruType,
										form.value.enAnnotation,
										form.value.enName,
										form.value.enType,
										this.statusText,
										this.selGroups,
										this.selUsers,
										this.selPositions,
										this.treeGroupPosService.getReadeForServer()
									);

									this.adminService.createStandard(newStandard, this.isSelected).subscribe( 
										(response: any) => {
											if (response.status === 201 || response.status === 200) { 
												const standard = response.body;
												this.standard = standard;
												this.flag = false;
												this.addQuestionsToStandard(this.standard);
											} else if (response.status === 208) {
												this.creatingStatusText = '';
												this.showCreateError = true;
												this.errorMessage = 'T_TRY';
												this.disableBtnCreateStandard = false;
											}
										},
										() => {
											this.creatingStatusText = '';
											this.errorMessage = 'ERROR_CREATING_THIS_STANDARD';
											this.failedStandardCreation = true;
											this.disableBtnCreateStandard = false;
										}
									);

								} else {
									this.creatingStatusText = '';
									this.showCreateError = true;
									this.errorMessage = 'SBIINF';
									this.disableBtnCreateStandard = false;
								}

							} else {
								this.creatingStatusText = '';
								this.showCreateError = true;
								this.errorMessage = 'M_S_L';
								this.disableBtnCreateStandard = false;
							}
						} else {
							this.creatingStatusText = '';
							this.showCreateError = true;
							this.errorMessage = 'M_S_L';
							this.disableBtnCreateStandard = false;
						}
					} else {
						this.creatingStatusText = '';
						this.showCreateError = true;
						this.errorMessage = 'Type error in Step 1: add a Type for the selected division.';
						this.disableBtnCreateStandard = false;
					}

				} else {
					this.creatingStatusText = '';
					this.showCreateError = true;
					this.errorMessage = 'S_P_D_S';
					this.disableBtnCreateStandard = false;
				}

			} else {
				this.creatingStatusText = '';
				this.showCreateError = true;
				this.errorMessage = 'F_X_S';
				this.disableBtnCreateStandard = false;
			}
		}
		this.isLoaded = true;
	}

	private addQuestionsToStandard(standard: Standard) {
		this.isLoaded = false;
		this.creatingStatusText = 'ADDING_QUESTIONS';
		for (const inputQuestion of this.questionList) {
			let answers: Answer[] = [];
			answers.push(
				new Answer(inputQuestion.answers[0].answerOneRu),
				new Answer(inputQuestion.answers[0].answerTwoRu),
				new Answer(inputQuestion.answers[0].answerThreeRu),
			);
			let rightAnswer: Answer;
			switch (inputQuestion.rightAnswerRu) {
				case '1':
					rightAnswer = answers[0];
					break;
				case '2':
					rightAnswer = answers[1];
					break;
				case '3':
					rightAnswer = answers[2];
					break;
			}
			const russianQuestion: Question = new Question(answers, inputQuestion.checked, inputQuestion.questionTextRu, rightAnswer);
			answers = [];
			answers.push(
				new Answer(inputQuestion.answers[0].answerOneEn),
				new Answer(inputQuestion.answers[0].answerTwoEn),
				new Answer(inputQuestion.answers[0].answerThreeEn),
			);
			switch (inputQuestion.rightAnswerEn) {
				case '1':
					rightAnswer = answers[0];
					break;
				case '2':
					rightAnswer = answers[1];
					break;
				case '3':
					rightAnswer = answers[2];
					break;
			}
			const englishQuestion: Question = new Question(answers, inputQuestion.checked, inputQuestion.questionTextEn, rightAnswer);
			this.russianQuestions.push(russianQuestion);
			this.englishQuestions.push(englishQuestion);
		}
		const allQuestions: MultiQuestions = new MultiQuestions(this.russianQuestions, this.englishQuestions);
		this.adminService.addQuestionsToStandard(allQuestions, standard.id).subscribe(
			(response: any) => {
				if (response.status === 201 || response.status === 200) {
					this.russianQuestions = [];
					this.englishQuestions = [];
					
					this.uploadFiles(this.standard);

				} else {
					this.creatingStatusText = '';
					this.showCreateError = true;
					this.errorMessage = 'E_B_T_A';
					this.disableBtnCreateStandard = false;
				}
			},
			() => {
				this.creatingStatusText = '';
				this.showCreateError = true;
				this.errorMessage = 'E_B_T_A';
				this.disableBtnCreateStandard = false;
			}
		);
	}

	blanksChange(event, index: number) {
		const fileList = event.target.files;
		if (fileList.length > 0) {
			const file: File = fileList[0];
			const formData = new FormData();
			formData.append('file', file, file.name);
			this.newBlanks[index].formData = formData;
		}
	}

	private uploadFiles(standard: Standard) {
		this.creatingStatusText = 'UPLOADING_FILES';
		this.isLoaded = false;
		this.adminService.uploadFiles(standard, this.formData).subscribe(
			(res: any) => {
				this.isLoaded = false;
				if (res.status === 200 || res.status === 201) {
					this.uploadBlanks(this.standard);
				} else {
					this.creatingStatusText = '';
					this.showCreateError = true;
					this.errorMessage = 'E_B_S_T';
					this.disableBtnCreateStandard = false;
					this.isLoaded = true;
				}
			}, () => {
				this.creatingStatusText = '';
				this.showCreateError = true;
				this.errorMessage = 'E_B_S_T';
				this.disableBtnCreateStandard = false;
				this.isLoaded = true;
			}
		);
	}

	private uploadBlanks(standard: Standard) {
		this.isLoaded = false;
		if (this.newBlanks.length > 0) {
			this.creatingStatusText = 'UPLOADING_BLANKS';
			this.isLoaded = false;
			this.adminService.uploadBlank(standard, this.newBlanks).subscribe(
				(res: any) => {
					this.isLoaded = false;
					if (res.status === 200 || res.status === 201) {
						this.createSuccess = true;
						this.disableBtnCreateStandard = false;
						this.creatingStatusText = 'DO';

						// Update counter
						this.setCounterNum(this.prefixService.getSelectedPrefix());
						this.isLoaded = true;
					} else {
						this.creatingStatusText = '';
						this.showCreateError = true;
						this.errorMessage = 'E_B_S_T_A';
						this.disableBtnCreateStandard = false;
						this.isLoaded = true;
					}
				},
				() => {
					this.creatingStatusText = '';
					this.showCreateError = true;
					this.errorMessage = 'E_B_S_T_A';
					this.disableBtnCreateStandard = false;
					this.isLoaded = true;
				}
			);
		} else {
			// Update counter
			this.setCounterNum(this.prefixService.getSelectedPrefix());
			this.isLoaded = true;
			this.creatingStatusText = '';
			this.createSuccess = true;
			this.disableBtnCreateStandard = false;
		}
		this.isLoaded = true;
	}

	isValid(form: NgForm) {
		return form.value.ruAnnotation !== '' && form.value.ruAnnotation != null
			&& form.value.ruName !== '' && form.value.ruName != null;
	}

	fieldsChangeGroup(values: any, group) { // JUST
		if(this.isSelected) {
			this.isSelected = false;
		} else {
			this.isSelected = true;
		}
		
	}

	chekQuestionArrValue() {
		var n = this.questionList.length;
		for (var i = 0; i < n; i++){
		 if (this.questionList[i].questionTextRu === '' || 
     this.questionList[i].answers[0].answerOneRu === '' || 
     this.questionList[i].answers[0].answerTwoRu === '' || 
     this.questionList[i].answers[0].answerThreeRu === '' ||
     this.questionList[i].rightAnswerRu === '') 
     return false; }
		return true;
	}

	isQuestionsValid() {
		for (const question of this.questionList) {
			if (question.questionTextRu === ''
				|| question.questionTextEn === ''
				|| (question.rightAnswerRu < 1 || question.rightAnswerRu > 3)
				|| (question.rightAnswerEn < 1 || question.rightAnswerEn > 3)) {
				return false;
			}
			for (const answer of question.answers) {
				if (answer.answerOneRu === ''
					|| answer.answerTwoRu === ''
					|| answer.answerThreeRu === ''
					|| answer.answerOneEn === ''
					|| answer.answerTwoEn === ''
					|| answer.answerThreeEn === '') {
					return false;
				}
				if (answer.answerOneRu === answer.answerTwoRu) {
					return false;
				}
				if (answer.answerTwoRu === answer.answerThreeRu) {
					return false;
				}
				if (answer.answerOneRu === answer.answerThreeRu) {
					return false;
				}
				if (answer.answerOneEn === answer.answerTwoEn) {
					return false;
				}
				if (answer.answerTwoEn === answer.answerThreeEn) {
					return false;
				}
				if (answer.answerOneEn === answer.answerThreeEn) {
					return false;
				}
			}
		}
		return true;
	}

	setNumberPrefix(prefixName) {
		const prefixObj = this.prefixService.getGroupPrefixex().find(i => i.name === prefixName);
		this.prefixService.setSelectedPrefix(prefixObj);

		this.setCounterNum(prefixObj);
		this.prefixService.customStndNumber = this.prefixService.getSelectedPrefix().name + this.generadedNumber;
	}

	// UPDATE TYPES IN TYPES LIST IN SERVICE
	updateTypes(listOfTypes) {
		if (listOfTypes !== null && listOfTypes !== undefined) {
			this.prefixService.updateTypesList(listOfTypes);
		} else {
			this.prefixService.updateTypesList([]);
		}
	}

	setCounterNum(prefixObj) {
		if (prefixObj) {
			this.prefixService.getCountStandardNumber(prefixObj.id).subscribe(
				(response: any) => {
					this.numberCountToday = Number(response.body) + 1;
					this.generadedNumber = '.' + this.numberCountToday + '.' + this.stringDate;
					this.prefixService.customStndNumber = prefixObj.name + this.generadedNumber;
				},
				() => {
				}
			);
		} else {
			this.numberCountToday = 1;
			this.generadedNumber = '.' + this.numberCountToday + '.' + this.stringDate;
			this.prefixService.customStndNumber = prefixObj.name + this.generadedNumber;
		}
	}

	setType(typeID) {
		const typeObj = this.standardTypesService.getTypesList().find(i => i.id === typeID);
		this.standardTypesService.setSelectedType(typeObj);
		this.selectedType = typeObj;
	}

	openAddNewPrefixModal() {
		const addPrefix = this.modalService.open(AddStandardPrefixComponent);
		addPrefix.componentInstance.setPrefixList(this.prefixService.getGroupPrefixex());
		addPrefix.componentInstance.setGroupForNewPrefix(this.selectedGroupObj);
		addPrefix.componentInstance.setStrinfDate(this.stringDate);
	}

	openEditPrefixModal() {
		if (this.prefixService.getSelectedPrefix().id) {
			const modalRef = this.modalService.open(EditStandardPrefixComponent);
			modalRef.componentInstance.setGroupForPrefix(this.prefixService.getSelectedPrefix());
		} else {
			this.retryGroups();
		}
	}

	openEditNumberModal() {
		let newStr = this.prefixService.customStndNumber.replace(this.prefixService.getSelectedPrefix().name, '');
		const modalRef = this.modalService.open(EditStandardNumberComponent);
		modalRef.componentInstance.setCurrentNumber(newStr);
	}

	openAddNewTypeModal() {
		const modalRef = this.modalService.open(AddStandardTypeComponent);
		modalRef.componentInstance.setTypeMainGroup(this.selectedGroupObj);
	}

	openEditTypeModal() {
		const modalRef = this.modalService.open(EditStandardTypeComponent);
		modalRef.componentInstance.setTypeMainGroup(this.selectedGroupObj);
	}

	setDivisionInitiator(groupID) {
		const groupObj = this.groups.find(i => i.id === groupID);
		this.selectedGroupObj = groupObj;
		var result = this.groups.filter(elem=>elem.id == groupID);
		this.users = [];
		this.users.push(result[0].head);
		this.initiator = this.users[0];
		this.prefixService.setActiveInitiatorGroup(groupObj);
		this.groupStandardId = groupID;
		this.retryGroups();
	}

	filterBy(prop: string, list: string) {
		if (list === 'departments') {
			if (this.groups !== undefined) {
				return this.groups.sort((a, b) => a[prop].toLowerCase() > b[prop].toLowerCase() ? 1 : a[prop].toLowerCase() === b[prop].toLowerCase() ? 0 : -1);
			}
		}
		if (list === 'users') {
			if (this.users !== undefined) {
				return this.users.sort((a, b) => a[prop] > b[prop] ? 1 : a[prop] === b[prop] ? 0 : -1);
			}
		}
	}

	getDepartmentById(id) {
		// this.getUsersByIdGroup(id);
		this.setDivisionInitiator(id);
	}

	onNextButtonMouseEnter(step: number) {
		this.isNextButtonHovered = true;
		if (step === 1) {
			this.updateStep1FieldHighlights();
		} else if (step === 2) {
			this.updateStep2FieldHighlights();
		}
	}

	onNextButtonMouseLeave() {
		this.isNextButtonHovered = false;
		this.highlightStep1Name = false;
		this.highlightStep1Annotation = false;
		this.highlightStep2Document = false;
	}

	updateStep1FieldHighlights() {
		const nameInput = document.querySelector('input[name="ruName"]') as HTMLInputElement;
		const annotationInput = document.querySelector('input[name="ruAnnotation"]') as HTMLInputElement;
		
		this.highlightStep1Name = !nameInput || !nameInput.value || nameInput.value.trim() === '';
		this.highlightStep1Annotation = !annotationInput || !annotationInput.value || annotationInput.value.trim() === '';
	}

	updateStep2FieldHighlights() {
		this.highlightStep2Document = !this.formData.has('RU_DOC');
	}
}



// WEBPACK FOOTER //
// C:/work/internal-frontend/src/app/content-page/admin/create-standard/create-standard.component.ts